// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Steps__stepsLine___R6X8c {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 50%;
    height: 0.2rem;
    margin-right: 0.4rem;

    background-color: var(--color-bg-ghost);
}

.Steps__error___Gny10 {
    background: var(--color-bg-alert);
}

.Steps__ready___JwAgn {
    background: var(--color-bg-success);
}

.Steps__pause___WJHdG {
    background: var(--color-bg-warning);
}

.Steps__default___HEF7C {
    background: var(--color-bg-normal);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/FileImport/Steps/Steps.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,UAAU;IACV,cAAc;IACd,oBAAoB;;IAEpB,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".stepsLine {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    width: 50%;\n    height: 0.2rem;\n    margin-right: 0.4rem;\n\n    background-color: var(--color-bg-ghost);\n}\n\n.error {\n    background: var(--color-bg-alert);\n}\n\n.ready {\n    background: var(--color-bg-success);\n}\n\n.pause {\n    background: var(--color-bg-warning);\n}\n\n.default {\n    background: var(--color-bg-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepsLine": `Steps__stepsLine___R6X8c`,
	"error": `Steps__error___Gny10`,
	"ready": `Steps__ready___JwAgn`,
	"pause": `Steps__pause___WJHdG`,
	"default": `Steps__default___HEF7C`
};
export default ___CSS_LOADER_EXPORT___;
